import { render } from "./BeneficiaryBadgeShow.vue?vue&type=template&id=2da6d396"
import script from "./BeneficiaryBadgeShow.vue?vue&type=script&lang=js"
export * from "./BeneficiaryBadgeShow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__